import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Form from '../../../../common/form'
import { sendRecoveryEmail } from '../../../../../data/auth/recover'
import { useLanguage } from '../../../../../data/state/hooks/language'

type ForgotPasswordFormProps = {
  onSuccess: () => void
  isDialog: boolean
}

const ForgotPasswordForm: React.FunctionComponent<ForgotPasswordFormProps> = ({ onSuccess, isDialog }) => {
    const [email, setEmail] = useState("")
    const [error, setError] = useState<string|null>(null)

    const { full, main } = useLanguage()

    const { t } = useTranslation("authorization")

    return (
        <Form
            title={t("forgot_password.title")}
            description={t("forgot_password.enter_email")}
            inputs={[
                { type: "email", placeholder: t("labels.email"), name: "email", onChange: ev => setEmail(ev.target.value), error }
            ]}
            button_name="Send recovery email"
            button_on_tap={async () => {
                const { error } = await sendRecoveryEmail(email, main)
                if (error) {
                    setError(t("forgot_password.error_not_found"))
                    return
                }

                setError(t("forgot_password.email_sent"))
            }}
        >
        </Form>
    )
}

export default ForgotPasswordForm